/* globals Landbot */

import Landbot, { LandbotContext } from "src/components/Bots/Landbot";
import React, { FC, useEffect, useState } from "react";

import Analytics from "../../lib/analytics/analytics";
import { BikeType } from "types";
import Button from "@material-ui/core/Button";
import { TheCycleverseTheme } from "src/theme";
import { makeStyles } from "@material-ui/core/styles";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    margin: theme.spacing(2),
    marginBottom: theme.spacing(6),
    textAlign: "center",
  },
  headline1: {
    ...theme.headline2,
    fontWeight: 300,
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("xs")]: {
      fontSize: 20,
    },
  },
  headline2: {
    fontSize: 36,
    marginTop: 0,
    marginBottom: theme.spacing(8),
    fontFamily: theme.highlightFontFamily,
    fontWeight: 900,
    maxWidth: 900,
    display: "inline-block",
    lineHeight: "1.1",
  },
  content: {
    textAlign: "left",
    maxWidth: 800,
    display: "inline-block",
    fontSize: "medium",
    "& b,strong": {
      fontWeight: 900,
    },
    "& h2": {
      ...theme.headline2,
      fontWeight: 300,
      marginTop: theme.spacing(4),
      [theme.breakpoints.down("xs")]: {
        fontSize: 20,
      },
    },
  },
  landbot: {
    width: "100%",
    height: 500,
    "& .LandbotFrame": {
      height: 500,
    },
  },
  startButton: {
    color: theme.palette.background.secondary,
    backgroundColor: theme.openButtonColor,
    marginBottom: theme.spacing(8),
    marginTop: theme.spacing(4),
    padding: "8px 16px",
    fontSize: 18,
  },
  separator: {
    height: 1,
    // NOTE: this is the fallback for old browsers if the next one
    // doesn't make sense to them
    background: theme.highlightGradientBg,
    // eslint-disable-next-line no-dupe-keys
    // @ts-ignore
    background: theme.highlightGradient,
  },
}));

const Content: FC<{ content: any; flavor: BikeType; translationsNamespace: string }> = ({
  content,
  flavor,
  translationsNamespace,
}) => {
  const { t } = useTranslation(translationsNamespace);
  const classes = useStyles();
  const landbotContext = React.useContext(LandbotContext);

  const launchBot = React.useCallback(() => {
    landbotContext.launchBot();
  }, [landbotContext]);

  return (
    <div className={classes.root}>
      <h1 className={classes.headline1}>{t("bikeFinderHeadline1")}</h1>
      <h2 className={classes.headline2}>{t("bikeFinderHeadline2")}</h2>

      <div>
        <img
          loading="lazy"
          src={
            flavor == "ebike"
              ? "https://images.thecycleverse.com/E-Clara-black.svg"
              : "https://images.thecycleverse.com/clara.svg"
          }
          width={60}
          height={55}
          alt="clara"
        />
      </div>

      <div>
        <Button
          className={classes.startButton}
          onClick={() => {
            launchBot();
          }}
        >
          {t("bikeFinderStart")}
        </Button>
      </div>

      <div className={classes.separator} />

      <div className={classes.content}>{content}</div>

      <div>
        <Button
          className={classes.startButton}
          onClick={() => {
            launchBot();
          }}
        >
          {t("bikeFinderStart")}
        </Button>
      </div>
    </div>
  );
};

const BikeFinder: FC<{ landbotUrl: string; content: any; flavor: BikeType; translationsNamespace: string }> = ({
  landbotUrl,
  content,
  flavor,
  translationsNamespace,
}) => {
  return (
    <Landbot
      landbotUrl={landbotUrl}
      onLaunchBot={() => {
        Analytics.botStart(`bikeFinder-${flavor}`);
      }}
    >
      <Content translationsNamespace={translationsNamespace} flavor={flavor} content={content} />
    </Landbot>
  );
};

export default BikeFinder;
